"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: Bug content type icon
var Bug = function Bug(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M12 21C10.9167 21 9.91253 20.7333 8.9875 20.2C8.0625 19.6667 7.33334 18.9333 6.80001 18H4.00001V16H6.10001C6.05001 15.6667 6.02084 15.3333 6.0125 15C6.00417 14.6667 6.00001 14.3333 6.00001 14H4.00001V12H6.00001C6.00001 11.6667 6.00417 11.3333 6.0125 11C6.02084 10.6667 6.05001 10.3333 6.10001 10H4.00001V8H6.80001C7.03334 7.61667 7.29584 7.25833 7.5875 6.925C7.87917 6.59167 8.21667 6.3 8.60001 6.05L6.99999 4.4L8.40001 3L10.55 5.15C11.0167 5 11.4917 4.925 11.975 4.925C12.4583 4.925 12.9333 5 13.4 5.15L15.6 3L17 4.4L15.35 6.05C15.7333 6.3 16.0792 6.5875 16.3875 6.9125C16.6958 7.2375 16.9667 7.6 17.2 8H20V10H17.9C17.95 10.3333 17.9792 10.6667 17.9875 11C17.9958 11.3333 18 11.6667 18 12H20V14H18C18 14.3333 17.9958 14.6667 17.9875 15C17.9792 15.3333 17.95 15.6667 17.9 16H20V18H17.2C16.6667 18.9333 15.9375 19.6667 15.0125 20.2C14.0875 20.7333 13.0833 21 12 21ZM10 16H14V14H10V16ZM10 12H14V10H10V12Z"
  }));
};

var _default = Bug;
exports.default = _default;